/**
 * Performance Optimizations Module
 * Handles lazy loading of heavy scripts (especially Swiper - 4.7s CPU savings)
 */

(function() {
  'use strict';
  
  var loaded = {
    swiper: false,
    swiperLoading: false,
    tracking: false
  };

  // Use global queue from inline stub, or create new one
  var swiperQueue = window._swiperQueue || [];
  var swiperCallbacks = [];

  /**
   * Execute all queued Swiper initializations once real library loads
   */
  function executeQueuedSwipers() {
    if (!window.Swiper || window.Swiper._isStub) return;
    
    // Process queue from inline stub
    var queue = window._swiperQueue || swiperQueue;
    queue.forEach(function(item) {
      if (item.d) return; // destroyed
      try {
        // Handle both queue formats (inline vs this module)
        var selector = item.s || item.selector;
        var options = item.o || item.options;
        item.instance = new window.Swiper(selector, options);
      } catch(e) {
        console.warn('Swiper init error:', e);
      }
    });
    
    // Clear queues
    if (window._swiperQueue) window._swiperQueue.length = 0;
    swiperQueue.length = 0;
    
    // Execute callbacks
    swiperCallbacks.forEach(function(cb) {
      try { cb(); } catch(e) {}
    });
    swiperCallbacks = [];
  }

  /**
   * Load Swiper library dynamically when needed
   * Saves ~4.7s CPU time by not loading on initial page load
   */
  window.loadSwiper = function(callback) {
    if (callback) swiperCallbacks.push(callback);
    
    if (loaded.swiper && window.Swiper && !window.Swiper._isStub) {
      executeQueuedSwipers();
      return;
    }
    
    if (loaded.swiperLoading) return;
    loaded.swiperLoading = true;
    
    var script = document.createElement('script');
    script.src = window.swiperBundleUrl;
    
    if (!script.src) {
      console.warn('Swiper URL not found');
      return;
    }
    
    script.onload = function() {
      loaded.swiper = true;
      executeQueuedSwipers();
      document.dispatchEvent(new CustomEvent('swiper:loaded'));
    };
    document.body.appendChild(script);
  };

  /**
   * Intersection Observer for lazy loading Swiper sections
   * Loads Swiper 300px before elements enter viewport
   */
  function initSwiperLazyLoad() {
    var swiperElements = document.querySelectorAll('.swiper, [class*="swiper"], [data-swiper-lazy]');
    
    if (!swiperElements.length) {
      // No swiper elements yet - may be added dynamically
      return;
    }
    
    if (!('IntersectionObserver' in window)) {
      // Fallback for older browsers - load immediately
      setTimeout(function() { window.loadSwiper(); }, 100);
      return;
    }
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          window.loadSwiper();
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '300px 0px', // Load 300px before element enters viewport
      threshold: 0
    });
    
    swiperElements.forEach(function(el) {
      observer.observe(el);
    });
    
    // Also load on any user scroll (backup)
    var scrollHandler = function() {
      window.loadSwiper();
      window.removeEventListener('scroll', scrollHandler);
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  /**
   * Delayed Heavy Third-Party Scripts
   * Loads on user interaction or after timeout
   */
  function loadDelayedScripts() {
    if (loaded.tracking) return;
    loaded.tracking = true;

    // Choozle/Ensighten (was loading synchronously)
    var ensighten = document.createElement('script');
    ensighten.src = '//nexus.ensighten.com/choozle/20245/Bootstrap.js';
    ensighten.defer = true;
    document.head.appendChild(ensighten);

    // Remove event listeners
    removeInteractionListeners();
  }

  function removeInteractionListeners() {
    document.removeEventListener('scroll', loadDelayedScripts);
    document.removeEventListener('click', loadDelayedScripts);
    document.removeEventListener('touchstart', loadDelayedScripts);
    document.removeEventListener('mousemove', loadDelayedScripts);
  }

  /**
   * Initialize lazy loading and deferred scripts
   */
  function init() {
    // Initialize Swiper lazy loading
    initSwiperLazyLoad();
    
    // Add interaction listeners for delayed scripts
    document.addEventListener('scroll', loadDelayedScripts, { once: true, passive: true });
    document.addEventListener('click', loadDelayedScripts, { once: true });
    document.addEventListener('touchstart', loadDelayedScripts, { once: true, passive: true });
    document.addEventListener('mousemove', loadDelayedScripts, { once: true, passive: true });
    
    // Fallback: load after 5 seconds if no interaction
    setTimeout(loadDelayedScripts, 5000);
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
